import { Component } from '@angular/core';
import { PanAppState, PlatformEnum, PlatformService } from '@panamax/app-state';
import { Observable } from 'rxjs';
import { ScoopService } from './services/scoop.service';
import { SneakPeekProduct } from './models/sneak-peek-product-view.model';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { TranslateService } from '@ngx-translate/core';
import { NavigationHelperService } from '@shared/helpers/navigation.helpers.service';
import { ProductAnalyticsService } from '@usf/ngrx-product';

@Component({
  selector: 'app-scoop',
  templateUrl: './scoop.page.html',
  styleUrls: ['./scoop.page.scss'],
})
export class ScoopPage {
  isDescriptionExpanded: boolean;
  sneakPeeks$: Observable<SneakPeekProduct[]>;

  constructor(
    readonly platformService: PlatformService,
    private navigationHelperService: NavigationHelperService,
    private panAppState: PanAppState,
    private productAnalyticsService: ProductAnalyticsService,
    private scoopService: ScoopService,
    private translateService: TranslateService,
  ) {}

  ionViewWillEnter() {
    this.productAnalyticsService.trackScoopPageLoad();
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.scoop),
    );
    this.isDescriptionExpanded =
      this.platformService.getPlatformType() !== PlatformEnum.mobile;

    this.sneakPeeks$ = this.scoopService.getSneakPeeks$();
  }

  expandDescription() {
    this.isDescriptionExpanded = !this.isDescriptionExpanded;
  }

  onProductClick(event: any) {
    this.navigationHelperService.routeToProductDetailsQueryParams(
      event.productNumber,
      { lnksrc: event.lnksrc, merchRank: event.merchRank },
    );
  }
}
